import { z } from 'zod';
import {
  CommunicationId,
  FamilyId,
  StudentId,
  UserId,
} from '../types/branded';
import { CommunicationChannelSchema, MessageDirectionSchema, CommunicationStatusSchema } from '../types/enums';

export const CommunicationSchema = z.object({
  id: CommunicationId,
  familyId: FamilyId,
  studentId: StudentId.nullable().optional(),
  channel: CommunicationChannelSchema,
  direction: MessageDirectionSchema,
  subject: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  senderId: UserId.nullable().optional(),
  senderName: z.string().nullable().optional(),
  recipient: z.string().nullable().optional(),
  recipientName: z.string().nullable().optional(),
  status: CommunicationStatusSchema,
  error: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  sentAt: z.string().nullable().optional(),
  createdAt: z.string(),
});
export type Communication = z.infer<typeof CommunicationSchema>;
